<template>
  <div>
    <slot v-if="!!signableWallet"></slot>
    <template v-else>
      <div class="text-center text-4">
        Connect {{ article }}
        <span class="text-capitalize">{{
          project && project.config.network
        }}</span>
        wallet to continue.
      </div>
      <div class="mt-8 text-center">
        <c-btn @click="connectWallet">Connect Wallet</c-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ECOSYSTEMS from "@/common/config/ecosystems";

export default {
  name: "AuthRenderer",
  computed: {
    ...mapGetters({
      project: "projectConfig/latestProject",
      signableWallet: "userWallets/signableWallet",
      isAuthenticated: "auth/isAuthenticated",
    }),
    currentEcosystem() {
      return ECOSYSTEMS.find((eco) =>
        eco.projects.includes(this.project.config.network)
      );
    },
    article() {
      if (!this.project) return "";
      return ["a", "e", "i", "o", "u"].includes(this.project.config.network[0])
        ? "an"
        : "a";
    },
  },
  methods: {
    connectWallet() {
      if (!this.isAuthenticated) {
        return this.$store.dispatch("setAuthModal", {
          shouldShow: true,
          component: "GetStarted",
          width: "604",
          data: {
            ecosystem: this.currentEcosystem?.name,
            project: this.project.name,
          },
        });
      }
      this.$store.dispatch("showSelectWalletModal", {
        ecosystem: this.currentEcosystem?.name,
        project: this.project.name,
      });
    },
  },
};
</script>